import { gql } from "@apollo/client";

export const CREATE_CONTACT_MANAGEMENT = gql`
  mutation CreateContactManagement($input: contactManagementInput) {
    createContactManagement(input: $input) {
      Id
    }
  }
`;



































